export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="bg-green-700 text-white py-8">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold text-center">プライバシーポリシー</h1>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-lg shadow-lg p-8">
            
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-green-700 mb-4">個人情報の取扱いについて</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                いーなくん20周年記念キャンペーン（以下「本キャンペーン」）では、お客様の個人情報を以下の通り取り扱います。
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold text-green-700 mb-3">1. 収集する個人情報</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>保護者様のお名前・フリガナ</li>
                <li>郵便番号・ご住所</li>
                <li>電話番号</li>
                <li>メールアドレス</li>
                <li>お子様の年齢</li>
                <li>希望受取店舗</li>
              </ul>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold text-green-700 mb-3">2. 利用目的</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>キャンペーンの抽選・当選通知</li>
                <li>プレゼントの発送・引換券の送付</li>
                <li>お問い合わせへの対応</li>
                <li>キャンペーンに関する重要なお知らせ</li>
              </ul>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold text-green-700 mb-3">3. 第三者への提供</h3>
              <p className="text-gray-700 leading-relaxed">
                お客様の個人情報は、法令に基づく場合を除き、お客様の同意なく第三者に提供することはありません。
                ただし、プレゼントの配送業務において、配送業者に必要最小限の情報を提供する場合があります。
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold text-green-700 mb-3">4. 個人情報の保管・管理</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                収集した個人情報は、適切なセキュリティ対策を講じて管理し、キャンペーン終了後は適切に廃棄いたします。
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>保管期間：キャンペーン終了後6ヶ月間</li>
                <li>管理方法：暗号化・アクセス制限等の安全管理措置</li>
                <li>廃棄方法：復元不可能な方法での完全削除</li>
              </ul>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold text-green-700 mb-3">5. お客様の権利</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                お客様は、ご自身の個人情報について以下の権利を有します：
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>開示・訂正・削除の請求</li>
                <li>利用停止の請求</li>
                <li>苦情・相談の申し出</li>
              </ul>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold text-green-700 mb-3">6. お問い合わせ窓口</h3>
              <div className="bg-green-50 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  個人情報の取扱いに関するお問い合わせは、以下のLINE公式アカウントまでご連絡ください。
                </p>
                <div className="text-center">
                  <a 
                    href="https://lin.ee/VikYXbC"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full font-bold shadow-lg transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-line-fill mr-2"></i>
                    LINE公式アカウント
                  </a>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold text-green-700 mb-3">7. 同意について</h3>
              <p className="text-gray-700 leading-relaxed">
                本キャンペーンにご応募いただくことで、本プライバシーポリシーにご同意いただいたものとみなします。
              </p>
            </section>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mt-8">
              <h3 className="text-lg font-bold text-yellow-800 mb-3">重要事項</h3>
              <ul className="text-yellow-700 space-y-2 text-sm">
                <li>• 本プライバシーポリシーは予告なく変更される場合があります</li>
                <li>• 変更後は本ページにて最新版を公開いたします</li>
                <li>• 継続してキャンペーンにご参加いただく場合は、変更後のポリシーに同意いただいたものとみなします</li>
              </ul>
            </div>

            <div className="text-center mt-12">
              <p className="text-gray-600 text-sm mb-4">最終更新日：2024年12月</p>
              <a 
                href="/"
                className="inline-block bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-full font-bold shadow-lg transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                キャンペーンページに戻る
              </a>
            </div>
          </div>
        </div>
      </main>

      {/* フッター */}
      <footer className="bg-green-700 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-green-200 text-sm">
            © 2024 いーなくん20周年記念キャンペーン. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}